import { Box, Divider, Spacer, Stack, Text } from '@chakra-ui/react';
import { Breadcrumbs } from '@diamond/shared/ui';

interface HighlightPageHeaderProps {
  title: string;
  breadcrumbs: Array<{ title: string; link: string }>;
}

export function HighlightPageHeader({
  title,
  breadcrumbs,
}: HighlightPageHeaderProps) {
  return (
    <>
      <Box paddingBottom={4}>
        <Breadcrumbs links={breadcrumbs} useRouterDom />
      </Box>
      <Box py={4}>
        <Stack spacing={8} direction="row" justifyContent="space-between">
          <Text fontSize="2xl" fontWeight="bold">
            {title}
          </Text>
          <Spacer />
        </Stack>
      </Box>
      <Divider />
    </>
  );
}
